import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { subscribe, unsubscribe } from '_ui-core-js/utilities/events.js';
import { randomString } from '_ui-core-js/utilities/randomString.js';
import { ImageRotator } from '_ui-core-js/React/components/ImageRotator.jsx';
import { LazyCCISImage } from '_ui-core-js/React/components/LazyCCISImage';

export function RetailModelCard(props) {
  
  const [isHovered, setIsHovered] = useState(false);
  const [triggerRotationReset, setTriggerRotationReset] = useState(false);
  const { block } = props;

  function mouseEnter() {
    setIsHovered(true);
  };

  function mouseLeave() {
    setIsHovered(false);
  };

  function resetImageRotation() {
    // setting a random string will trigger the reset effect to run in the imageRotator component.
    setTriggerRotationReset(randomString());
  };

  // Image rotation happens by default when hovering off od the card, however with this we can
  // listen to external events instead to reset the imaget rotation.
  useEffect(() => {
    if (props.imgRotationResetEventName) {
      subscribe(props.imgRotationResetEventName, resetImageRotation);
      return () => {
        unsubscribe(props.imgRotationResetEventName, resetImageRotation);
      }
    }
  }, []);

  return (
    <div 
    className={`${block} ${block}--retail-model ${props.modifierClass}`} 
    onMouseEnter={mouseEnter} 
    onMouseLeave={mouseLeave} 
    >
      { props.heading }
      <div 
      className={classNames({
        [`${block}__price-container`]: true,
        [`${block}__price-container--no-price`]: !props.priceValue || props.priceValue === '-'
      })}
      >
        <div className={`${block}__price-from small-text`}>{props.priceFromText}</div>
        <div className={`${block}__price-value h5`}>{props.priceValue}</div>
      </div>
      <div className={`${block}__image-container`}>
          <div className={`${block}__static-image`}>
            <LazyCCISImage {...{...props.ccisImgConfig}}/>
          </div>
      </div>
      { props.buttons }
    </div>
  )
};

RetailModelCard.propTypes = {
  block: propTypes.string.isRequired,
  modifierClass: propTypes.string,
  modelName: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  priceFromText: propTypes.string.isRequired,
  priceValue: propTypes.string.isRequired,
  ccisImgConfig: propTypes.object.isRequired,
  imgAltText: propTypes.string,
  buttonOneText: propTypes.string,
  buttonOneOnClickCallback: propTypes.func,
  buttonTwoText: propTypes.string,
  imgRotateOn: propTypes.string,
  imgRotationResetEventName: propTypes.string,
  trackingId: propTypes.string,
  baseModelName: propTypes.string
};

